<template>
	<div class='layout main' :class='{"no-sidebar": !this.$slots["sidebar"] && !this.$slots["sidebar2"], "no-headline": !this.$slots["headline"]}'>
		<slot name='headline' class='layout__headline' v-if='this.$slots["headline"]' />
		<h1 class='headline headline--l1 main__headline layout__headline' v-else-if='headline'>
			{{headline}}
		</h1>
		<div class='main__row'>
			<div class='main__sidebar' v-if='this.$slots["sidebar"]'>
				<nav data-simplebar class='sidebar' :class='{"sidebar--auto-height": autoHeightSidebar}'>
					<slot name='sidebar' />
					<div class='sidebar__sidebarbottom'>
						<slot name='sidebarbottom' />
					</div>
				</nav>
			</div>
			<div class='main__sidebar' v-if='this.$slots["sidebar2"]'>
				<slot name='sidebar2' />
			</div>
			<div class='main__content'>
				<slot name='filter'  v-if='this.$slots["filter"]' />
				<div class='layout__content' :class='{"content__main is-fixed-block": fixed}'>
					<slot name='btnTitle' />
					<h2 v-if='title' class='title'>{{title}}</h2>
					<slot />
				</div>
			</div>
		</div>
		<load v-if='load' />
		<Cropper />
		<Confirm />
		<Alert />
	</div>
</template>

<script>
import load from '__jsVueUI/load.vue';
import Cropper from '__jsVueSections/cropper/cropper.vue';
import Confirm from '__jsVueSections/Confirm/Confirm.vue';
import Alert from '__jsVueSections/Alert/Alert.vue';
import EventBus from '__jsEbentBus';
import global from '__jsVueMixin/global';
export default {
	name:       'Layout',
	mixins: [global],
	props:  {
		headline: {
			type:    String,
			default: ''
		},
		title: {
			type:    String,
			default: ''
		},
		autoHeightSidebar: {
			type:    Boolean,
			default: false
		},
		fixed: {
			type:    Boolean,
			default: false
		},
	},
	components: {
		load,
		Cropper,
		Confirm,
		Alert,
	},
	computed: {
		load() {
			return this.$store.state.main.load;
		}
	},
	created() {
		this.scrollListener = window.addEventListener('scroll', (e) => {
			EventBus.$emit('onscroll', e);
		});
		this.dynamichref = window.location.href;
	},
};
</script>
